module.exports = __webpack_public_path__ + "static/media/prio2.6d39b702.jpg";